/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_uc_categories_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All converters`)
};

const es_uc_categories_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todos los conversores`)
};

const de_uc_categories_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle Umrechner`)
};

const nl_uc_categories_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle converters`)
};

const fr_uc_categories_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tous les convertisseurs`)
};

const it_uc_categories_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tutti i convertitori`)
};

const pt_br2_uc_categories_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todos os conversores`)
};

const pt_uc_categories_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todos os conversores`)
};

const ja_uc_categories_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`すべてのコンバーター`)
};

const zh_uc_categories_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`所有换算器`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const uc_categories_title = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.uc_categories_title(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("uc_categories_title", locale)
	if (locale === "en") return en_uc_categories_title(inputs)
	if (locale === "es") return es_uc_categories_title(inputs)
	if (locale === "de") return de_uc_categories_title(inputs)
	if (locale === "nl") return nl_uc_categories_title(inputs)
	if (locale === "fr") return fr_uc_categories_title(inputs)
	if (locale === "it") return it_uc_categories_title(inputs)
	if (locale === "pt-BR") return pt_br2_uc_categories_title(inputs)
	if (locale === "pt") return pt_uc_categories_title(inputs)
	if (locale === "ja") return ja_uc_categories_title(inputs)
	return zh_uc_categories_title(inputs)
};